import React from 'react';
import {useTranslation} from 'react-i18next';

import {ESize, TSize} from '@edna/components';
import {formatDate, formatNumber} from '@edna/utils';

import {useGetTenantLeadDetailsQuery} from 'src/containers/LeadCompanyClients';

import {TBilledEventData} from '../definitions';
import * as S from '../style';

type TProps = {
  size?: TSize;
  billedEventData: TBilledEventData;
};

export const BilledEventDetails = React.memo<TProps>(({size = ESize.S, billedEventData}) => {
  const {t} = useTranslation();

  const {data: tenantLeadDetails} = useGetTenantLeadDetailsQuery(
    billedEventData.debtTransaction?.tenantId ?? billedEventData.transaction?.tenantId,
  );

  if (!tenantLeadDetails) {
    return null;
  }

  const {billedEvent, debtTransaction, transaction} = billedEventData;

  const amount = transaction?.amount ?? debtTransaction?.amount;
  const createdAt = transaction?.createdAt ?? debtTransaction?.createdAt;

  return (
    <S.Column>
      <S.InfoRow size={size}>
        <S.DetailsLabel>{t('Corrections:payments.storno.tenantId')}</S.DetailsLabel>
        {debtTransaction?.tenantId ?? transaction?.tenantId}
      </S.InfoRow>
      <S.InfoRow size={size}>
        <S.DetailsLabel>{t('Corrections:payments.storno.companyName')}</S.DetailsLabel>
        {tenantLeadDetails.companyName}
      </S.InfoRow>
      <S.InfoRow size={size}>
        <S.DetailsLabel>{t('Corrections:payments.storno.paymentType')}</S.DetailsLabel>
        {billedEvent?.originalEventType}
      </S.InfoRow>
      <S.InfoRow size={size}>
        <S.DetailsLabel>{t('Corrections:payments.storno.amount')}</S.DetailsLabel>
        {amount && formatNumber(amount)}
      </S.InfoRow>
      <S.InfoRow size={size}>
        <S.DetailsLabel>{t('Corrections:payments.storno.currency')}</S.DetailsLabel>
        {transaction?.currency ?? debtTransaction?.currency}
      </S.InfoRow>
      <S.InfoRow size={size}>
        <S.DetailsLabel>{t('Corrections:payments.storno.date')}</S.DetailsLabel>
        {createdAt && formatDate(new Date(createdAt), {format: 'dd.MM.yyyy'})}
      </S.InfoRow>
    </S.Column>
  );
});

BilledEventDetails.displayName = 'BilledEventDetails';
